// src/components/fuel/TruckPriceModal.js
import React from 'react';
import { Modal, Field, ModalFooter } from './modalComponents';
import { FUEL_META } from './constants';
import { fmtUSD } from './formatters';

const TruckPriceModal = ({ isOpen, onClose, truck, setTruck, onSave, saving }) => {
  if (!isOpen || !truck) return null;

  const fuelMeta = FUEL_META[truck.fuel_type] || FUEL_META['JetA'];

  return (
    <Modal title={`Update Price - ${truck.truck_number}`} onClose={onClose}>
      <div className="space-y-3">
        <div className="bg-gray-700/30 rounded-lg p-3 text-center">
          <span className={`px-2 py-1 rounded-lg text-xs font-semibold ${fuelMeta.badge}`}>
            {fuelMeta.label}
          </span>
          <p className="text-gray-400 text-xs mt-2">
            {truck.truck_name || truck.truck_number} · {Math.round(truck.current_volume_gallons || 0)} / {Math.round(truck.capacity_gallons || 0)} gal
          </p>
        </div>
        
        <Field label="Current Price per Gallon">
          <div className="text-white text-lg font-bold">{fmtUSD(truck.price_per_gallon || 6.85)}/gal</div>
        </Field>
        
        <Field label="New Price ($/gallon) *">
          <input 
            type="number" 
            min="0" 
            step="0.001"
            placeholder="6.850"
            value={truck.price_per_gallon || ''}
            onChange={e => setTruck({ ...truck, price_per_gallon: parseFloat(e.target.value) })}
            className="w-full bg-gray-700 border border-gray-600 rounded-lg p-2 text-white text-sm" 
          />
        </Field>
      </div>
      <ModalFooter 
        onCancel={onClose} 
        onSave={onSave}
        saving={saving} 
        disabled={!truck.price_per_gallon || truck.price_per_gallon <= 0} 
        label="Update Price" 
      />
    </Modal>
  );
};

export default TruckPriceModal;